<template>
  <div class="md-layout">
    <!-- CHAT LIST -->
    <div
      class="md-layout-item md-xlarge-size-20 md-large-size-25 md-medium-size-35 md-small-size-100 md-xsmall-size-100"
    >
      <md-list class="md-triple-line chatlist-scroller" style="margin: 30px 0;">
        <div v-for="item in chatList" :key="item.ID">
          <md-list-item
            @click="getMessages(item)"
            :class="[item.selected ? 'chatlist-selected' : '']"
          >
            <md-avatar>
              <img src="/img/enginer_icon.png" alt="People" />
            </md-avatar>

            <div class="md-list-item-text">
              <span v-if="!item.readed">
                <b>{{item.name}}</b>
              </span>
              <span v-else>{{item.name}}</span>
              <p v-if="!item.readed">
                <b>{{item.lastMsg}}</b>
              </p>
              <p v-else>{{item.lastMsg}}</p>
              <span>{{dateTimeFormat(item.timestamp)}}</span>
            </div>
          </md-list-item>

          <!-- <md-divider class="md-inset"></md-divider> -->
        </div>
      </md-list>
    </div>

    <!-- MESSAGES LIST -->
    <div
      class="md-layout-item md-xlarge-size-80 md-large-size-75 md-medium-size-65 md-small-size-100 md-xsmall-size-100"
    >
      <md-card>
        <!-- <md-card-header>
          <h4 class="title">{{selectedChat.title}}</h4>
        </md-card-header> -->

                <md-card-header class="md-card-header-icon md-card-header-blue">
          <div class="card-icon">
            <md-icon>message</md-icon>
          </div>
          <h4 class="title">{{selectedChat.title}}</h4>
        </md-card-header>

        <md-card-content>
          <div ref="chat" class="scroller">
            <Message
              v-for="msg in messagesList"
              :key="msg.ID"
              :positionLeft="msg.source == 'DISPATCHING' ? false : true"
              :msg="msg.msg"
              :timestamp="msg.timestamp"
              :stage="msg.stage ? Number(msg.stage) : null"
            />
          </div>
        </md-card-content>

        <md-card-actions>
          <div class="md-layout">
            <div class="md-layout-item" style="padding-bottom: 15px;">
              <md-field :class="[{ 'md-error': errors.has('SEND_MSG') }]">
                <md-input
                  v-model="newMessage"
                  @keyup.enter.native="sendMessage"
                  placeholder="Send message"
                  :maxlength="modelValidations.msgSend.max"
                  data-vv-name="SEND_MSG"
                  type="text"
                  name="SEND_MSG"
                  v-validate="modelValidations.msgSend"
                ></md-input>
                <slide-y-down-transition>
                  <md-icon class="error" v-show="errors.has('SEND_MSG')">close</md-icon>
                </slide-y-down-transition>
              </md-field>
            </div>
            <div
              class="send-button md-layout-item md-xlarge-size-10 md-large-size-15 md-medium-size-25 md-small-size-20 md-xsmall-size-100"
            >
                <md-button @click="sendMessage" class="md-info md-round">
                  <md-icon>send</md-icon>Send
                </md-button>
            </div>
          </div>
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import format from "date-fns/format";
import Message from "@/components/Message";
import { SlideYDownTransition } from "vue2-transitions";

export default {
  components: {
    Message,
    SlideYDownTransition
  },

  data() {
    return {
      modelValidations: {
        msgSend: {
          required: true,
          min: 2,
          max: 38
        }
      },
      chatList: [],
      messagesList: [],
      loading: true,
      newMessage: "",
      selectedChat: {
        title: "",
        LORA_ID: ""
      }
    };
  },

  computed: {
    getAuth() {
      return this.$store.getters.getAuth;
    },
    isConnected() {
      return this.$store.getters.isConnected;
    },
    getPayload() {
      return this.$store.getters.getPayload;
    }
  },

  watch: {
    isConnected: function(newStatus, oldStatus) {
      if (newStatus) {
        this.onNewMessageSub(true);
      }
    },
    getPayload: function(newMsg, oldMsg) {
      if (newMsg.event === "NEW_MSG") {
        const findIndex = this.chatList.findIndex(
          el => el.LORA_ID == newMsg.data.LORA_ID
        );
        if (findIndex !== -1) {
          this.chatList[findIndex].readed = false;
          this.chatList[findIndex].lastMsg = newMsg.data.msg;
          this.chatList[findIndex].timestamp = newMsg.data.timestamp;
        }

        if (this.selectedChat.LORA_ID == newMsg.data.LORA_ID) {
          this.messagesList.push({
            ID: newMsg.data.ID,
            msg: newMsg.data.msg,
            timestamp: new Date().getTime() / 1000,
            source: "SERVICER"
          });
        }
      } else if (newMsg.event === "NEW_MSG_STAGE") {
        if (this.selectedChat.LORA_ID == newMsg.data.LORA_ID) {
          const findIndex = this.messagesList.findIndex(
            msg => msg.ID == newMsg.data.ID
          );
          if (findIndex !== -1) {
            this.messagesList[findIndex].stage = newMsg.data.newStage;
          }
        }
      }
    }
  },

  beforeDestroy() {
    this.onNewMessageSub(false);
  },

  mounted() {
    this.onNewMessageSub(true);
    this.getChatList();
  },

  updated() {
    this.scrollToEnd();
  },

  methods: {
    onNewMessageSub(state) {
      const subscribeNewMessage = {
        token: this.getAuth.token,
        onNewMessage: state
      };
      try {
        this.$socket.send(JSON.stringify(subscribeNewMessage));
      } catch {}
    },

    scrollToEnd() {
      const container = this.$refs.chat;
      container.scrollTop = container.scrollHeight;
    },

    dateTimeFormat(value) {
      return format(value * 1000, "DD-MM-YYYY HH:mm:ss");
    },

    sendMessage() {
      this.$validator.validateAll().then(res => {
        if (res) {
          axios({
            method: "POST",
            url: this.$ENDPOINTS.API + "/send",
            headers: {
              Authorization: "Bearer " + this.getAuth.token
            },
            data: {
              LORA_ID: this.selectedChat.LORA_ID,
              msg: this.newMessage
            }
          })
            .then(response => {
              this.messagesList.push({
                ID: response.data.data.ID,
                msg: this.newMessage,
                timestamp: new Date().getTime() / 1000,
                source: "DISPATCHING",
                stage: 1
              });

              const findIndex = this.chatList.findIndex(
                el => el.LORA_ID == this.selectedChat.LORA_ID
              );
              if (findIndex !== -1) {
                this.chatList[findIndex].lastMsg = this.newMessage;
                this.chatList[findIndex].timestamp = new Date().getTime() / 1000;
              }

              this.newMessage = "";
              this.$validator.reset();
            })
            .catch(error => {
              console.log("Send ERROR: ", error);
            });
        }
      });
    },

    getChatList() {
      axios({
        method: "GET",
        url: this.$ENDPOINTS.API + "/chatlist",
        headers: {
          Authorization: "Bearer " + this.getAuth.token
        }
        //url: "https://run.mocky.io/v3/02e74e6f-8866-495d-98c3-5c5ecb11e944"
      })
        .then(response => {
          this.chatList = response.data.data;

          //Sorting newest first
          this.chatList.sort((a, b) => {
            if (a.timestamp < b.timestamp) {
              return 1;
            }
            if (a.timestamp > b.timestamp) {
              return -1;
            }
            return 0
          })

          
          this.getMessages(this.chatList[0]);
        })
        .catch(error => {
          console.log("ERROR: ", error);
        });
    },

    getMessages(chat) {
      this.loading = true;
      this.selectedChat = {
        title: chat.name,
        LORA_ID: chat.LORA_ID
      };
      this.chatList.map(el => (el.selected = false));

      this.chatSeenByUser(chat.LORA_ID);

      axios({
        method: "POST",
        //url: "https://run.mocky.io/v3/98bd8610-1cd5-4635-a97b-5ed1146ea817",
        url: this.$ENDPOINTS.API + "/messages",
        headers: {
          Authorization: "Bearer " + this.getAuth.token
        },
        data: {
          LORA_ID: chat.LORA_ID
        }
      })
        .then(response => {
          chat.selected = true;
          chat.readed = true;
          this.messagesList = response.data.data;
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
          console.log("ERROR: ", error);
        });
    },

    chatSeenByUser(LORA_ID) {
      axios({
        method: "POST",
        url: this.$ENDPOINTS.API + "/seen",
        headers: {
          Authorization: "Bearer " + this.getAuth.token
        },
        data: {
          LORA_ID: LORA_ID
        }
      })
        .then(response => {

        })
        .catch(error => {
          console.log("Seen ERROR: ", error);
        });
    }
  }
};
</script>

<style scoped>
.wrapper.wrapper-full-page {
  min-height: 90vh;
}

.scroller {
  height: 67vh;
  overflow-y: scroll;
}

.chatlist-scroller {
  height: 85vh;
  overflow-y: scroll;
}

.chatlist-selected {
  background-color: #eeeeee;
}

.send-button {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>